








import { Component, Emit, Vue } from 'vue-property-decorator';
import CustomerForm from '@/components/Customer/CustomerForm.vue';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_createCustomer } from '@/queries/__generated__/createCustomer';
import gql from 'graphql-tag';
import { customerFragments } from '@/queries/Customer';

const CREATE_CUSTOMER = gql`
  mutation createCustomer(
    $customer: CustomerCreate!,
  ) {
    createCustomer(
      input: { customer: $customer }
    ) {
      customer {
        ...customerFragments
      }
    }
  },
  ${customerFragments}
`;

@Component({
  components: {
    CustomerForm,
  },
})
export default class CustomerNew extends Vue {
  @SmartQuery<CustomerNew, GQL_currentUnit>({
    query: CURRENT_UNIT,
    result({ data }) {
      this.data.ownerId = data.currentUnit.id;
    },
  }) public currentUnit!: GQL_currentUnit;

  public CREATE_CUSTOMER = CREATE_CUSTOMER;

  public data = {
    ownerId: '',
    unit: {
      id: null,
      name: '',
      highestPriorityIdentity: {
        value: null,
        identificator: { name: null },
      },
      address: null,
      city: null,
      zip: null,
      country: { id: null, name: null },
      phone: null,
      mobile: null,
      email: null,
      isCompany: true,
    },
    unofficialName: null,
    unitId: '',
    deliveryLocations: [],
    customerContacts: [],
    creditDays: 0,
    reference: null,
    customEmail: null,
    customPhone: null,
    invoiceDeliveryMethod: null,
    autoSendInvoice: false,
    customerNumber: null,
  };

  @Emit()
  public customerCreated(store: InMemoryCache, query: {data: GQL_createCustomer }) {
    return query.data.createCustomer && query.data.createCustomer.customer!;
  }
}
